// extracted by mini-css-extract-plugin
module.exports = {"heading":"BasketItems-module__heading___cKghr","clearBasket":"BasketItems-module__clearBasket___3bI7a"};